import styled, { css } from 'styled-components';
import { Link } from '../../../common/components/Link';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import {
  Breakpoint,
  FontSize,
  FontWeight,
  FONT_STACK,
  LineHeight,
  LINK_STYLE,
  PRESSABLE,
  STANDARD_TRANSITION,
} from '../../../common/styles/constants';
import { onMobile } from '../../../common/styles/onMobile';
import Image from './NoResults.color.svg';

export const NoResultsContainer = styled.div`
  ${FONT_STACK};
  display: flex;
  flex-flow: row wrap;
  margin: 24px 0 0;

  ${Breakpoint.SMALL} {
    margin: 80px 0 0;
  }
`;

export const NoResultsView = styled.div<{ isLoading: boolean }>`
  ${STANDARD_TRANSITION};

  ${props =>
    props.isLoading &&
    css`
      opacity: 0.6;
    `}
`;

export const Sign = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 0 80px;
`;

export const StyledImage = styled(Image)`
  height: 44px;
  width: 44px;
`;

export const Message = styled.div`
  margin-inline-start: 16px;
  margin-top: 10px;
  text-align: center;

  ${onMobile} {
    margin-inline-start: 0;
  }
`;

export const HintHeader = styled.div`
  color: ${ThemeColours.black};
  font-size: 24px;
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: 32px;
  margin-bottom: 8px;

  ${onMobile} {
    font-size: 20px;
  }
`;

export const Hint = styled.div`
  color: ${ThemeColours.mono700};
  font-size: ${FontSize.BODY_REGULAR};
  line-height: ${LineHeight.BODY_REGULAR};
  padding: 0 16px;

  ${Breakpoint.SMALL} {
    font-size: ${FontSize.LARGE};
    line-height: ${LineHeight.LARGE};
    padding: 0;
  }
`;

export const HintListItemLink = styled.a`
  ${LINK_STYLE}
`;

export const Fallback = styled.div`
  background-color: ${ThemeColours.mono100};
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 24px 24px 64px;
  width: 100%;
`;

export const FallbackHeader = styled.div`
  color: ${ThemeColours.black};
  font-size: 18px;
  font-weight: ${FontWeight.SEMI_BOLD};
  width: 100%;
`;

export const LinkGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  width: 232px;
`;

export const LinkHeader = styled.div`
  color: ${ThemeColours.black};
  font-size: 16px;
  font-weight: ${FontWeight.SEMI_BOLD};
  margin-bottom: 16px;
`;

export const StyledLink = styled(Link)`
  ${PRESSABLE};
  color: ${ThemeColours.mono700};
  font-size: 16px;
  margin-bottom: 4px;
  text-decoration: none;
  width: fit-content;

  &:hover {
    text-decoration: underline;
  }
`;

export const AdContainer = styled.div`
  margin-bottom: 40px;
`;

export const GpAdsContainer = styled.div`
  margin-bottom: 24px;
  margin-top: -56px;

  ${Breakpoint.SMALL} {
    margin-bottom: 40px;
    margin-top: -40px;
  }
`;
